import { motion } from "framer-motion";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { waLink, MESSAGES } from "@/constants/site";

export const FloatingWhatsApp = () => (
  <motion.a
    href={waLink(MESSAGES.flutuante)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-btn"
    aria-label="Atendimento pelo WhatsApp"
    initial={{ opacity: 0, scale: 0, y: 30 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 2 }}
    whileHover={{ scale: 1.06 }}
    whileTap={{ scale: 0.94 }}
    className="fixed bottom-5 right-5 z-50 flex items-center gap-3 rounded-full bg-[#25D366] px-4 py-4 font-semibold text-white shadow-[0_8px_30px_rgba(37,211,102,0.45)] sm:bottom-6 sm:right-6 sm:px-5"
  >
    <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366]/40" />
    <WhatsAppIcon className="h-6 w-6" />
    <span className="hidden text-sm sm:inline">Atendimento WhatsApp</span>
  </motion.a>
);
